module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('div', {
    staticClass: "autocomplete__box",
    class: [_vm.inputClass, {
      'autocomplete__searching': _vm.showResults
    }]
  }, [(!_vm.isLoading) ? _c('img', {
    staticClass: "autocomplete__icon",
    attrs: {
      "src": require("../assets/search.svg")
    }
  }) : _c('img', {
    staticClass: "autocomplete__icon animate-spin",
    attrs: {
      "src": require("../assets/loading.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "autocomplete__inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display),
      expression: "display"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disableInput
    },
    domProps: {
      "value": (_vm.display)
    },
    on: {
      "click": _vm.search,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.display = $event.target.value
      }, _vm.search],
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.enter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.close($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.close($event)
      }],
      "focus": _vm.focus,
      "blur": _vm.blur
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": _vm.name,
      "type": "hidden"
    },
    domProps: {
      "value": _vm.value
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disableInput && !_vm.isEmpty && !_vm.isLoading && !_vm.hasError),
      expression: "!disableInput && !isEmpty && !isLoading && !hasError"
    }],
    staticClass: "autocomplete__icon autocomplete--clear",
    on: {
      "click": _vm.clear
    }
  }, [(_vm.clearButtonIcon) ? _c('span', {
    class: _vm.clearButtonIcon
  }) : _c('img', {
    attrs: {
      "src": require("../assets/close.svg")
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "autocomplete__results",
    style: (_vm.listStyle)
  }, [_vm._t("results", [(_vm.hasError) ? _c('li', {
    staticClass: "autocomplete__results__item autocomplete__results__item--error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.hasError) ? [_vm._t("firstResult"), _vm._v(" "), _vm._l((_vm.results), function(result, key) {
    return _c('li', {
      key: key,
      staticClass: "autocomplete__results__item",
      class: {
        'autocomplete__selected': _vm.isSelected(key)
      },
      domProps: {
        "innerHTML": _vm._s(_vm.formatDisplay(result))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(result)
        }
      }
    })
  }), _vm._v(" "), _vm._t("lastResult")] : _vm._e(), _vm._v(" "), (_vm.noResults && !_vm.isLoading && _vm.isFocussed && !_vm.hasError && _vm.showNoResults) ? _c('li', {
    staticClass: "autocomplete__results__item autocomplete__no-results"
  }, [_vm._v("Nothing found.")]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6016824a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = 41
// module chunks = 0